import { statusMeta, type TopicStatus } from '@/mocks/topics';

interface StatusBadgeProps {
  status: TopicStatus;
  size?: 'sm' | 'md';
  withShort?: boolean;
}

const toneClasses: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  secondary: 'bg-secondary-100 text-secondary-800 border-secondary-200',
};

export default function StatusBadge({ status, size = 'sm', withShort = false }: StatusBadgeProps) {
  const meta = statusMeta[status];
  const sizeClass = size === 'sm' ? 'text-xs px-2.5 py-1 gap-1' : 'text-sm px-3 py-1.5 gap-1.5';

  return (
    <span
      className={`inline-flex items-center rounded-full border font-label font-medium whitespace-nowrap ${sizeClass} ${toneClasses[meta.tone]}`}
    >
      <i className={`${meta.icon} text-sm`}></i>
      {withShort ? meta.short : meta.label}
    </span>
  );
}